export const regex_email =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const regex_number = /^[0-9]*$/

export const regex_date = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/

export const regex_year = /^\d{4}$/

export const regex_plate = /^([a-zA-Z]{2}[0-9]{3,4}[a-zA-Z]{2}|[a-zA-Z]{2}[0-9]{5})$/

export const regex_taxcode =
  /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/

export const regex_cuclass = /^(1[0-8]|[1-9])$/

export const regex_itclass = /^(4[0-4]|3[0-9]|2[2-9])$/

export const regex_nclaims = /^(([0-9]|[1-9][0-9]|[1-9][0-9][0-9])|ND|NA)$/

export const regex_50cc = /^([1-4][0-9]|50)$/
